import BaseImage from "@components/BaseImage";
import { WrapBridgeMappings } from "@constants/common";
import { Typography } from "@kelp-dao/kernel-design-system";

/**
 * The token identity shown inside an amount field, as an icon plus symbol.
 *
 * Every bridge and wrap field on this page renders one of these, so the icon
 * lookup and the transparent container live here rather than being repeated
 * per field. The container must stay transparent: the design system's default
 * right-element background reads as a white pill against a disabled field.
 *
 * Resolving the icon from the symbol keeps this correct for rsETH, wrsETH and
 * the agETH pair without the caller choosing an asset.
 */
const TokenBadge = ({ symbol }: { symbol: string }) => (
  <div className="flex items-center gap-1">
    <BaseImage
      src={
        WrapBridgeMappings.ICONS[symbol] || WrapBridgeMappings.ICONS.placeholder
      }
      alt={symbol}
      width={18}
      height={18}
    />
    <Typography variant="small" type="body" className="text-text-secondary">
      {symbol}
    </Typography>
  </div>
);

/** The className every field's right element uses, so they align identically. */
export const TOKEN_BADGE_CONTAINER =
  "h-[80%] px-2 flex items-center bg-transparent";

export default TokenBadge;
